import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Ellipses from '../../../../../Common/EllipsesControl/EllipsesPresets';

function BodySpecialAccordionContentList({title, columns, children, className, isProcessing}) {
	return (
		<StyledBodySpecialAccordionContentList
			className={`StyledBodySpecialAccordionContentList ${className}`}
			isProcessing={isProcessing}
		>
			{title ? (
				<StyledBodySpecialAccordionContentListTitle className="StyledBodySpecialAccordionContentListTitle">
					<Ellipses.Single>{title}</Ellipses.Single>
				</StyledBodySpecialAccordionContentListTitle>
			) : (
				<>
					{columns && columns.length > 0 && (
						<section className="body-special-accordion-content-list-header">
							{columns.map((column) => (
								<section className={column.className}>
									<span className="bodySpecialAccordionContentListHeaderText" onClick={column.onClick}>
										{column.title}
									</span>
								</section>
							))}
						</section>
					)}
				</>
			)}
			{children}
		</StyledBodySpecialAccordionContentList>
	);
}

export default BodySpecialAccordionContentList;

BodySpecialAccordionContentList.propTypes = {
	title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
	columns: PropTypes.arrayOf(
		PropTypes.shape({
			className: PropTypes.string,
			title: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
		})
	),
	children: PropTypes.node,
	className: PropTypes.string,
	isProcessing: PropTypes.bool
};

BodySpecialAccordionContentList.defaultProps = {
	className: 'StyledBodySpecialAccordionContentList'
};

const StyledBodySpecialAccordionContentList = styled.section`
	padding: var(--px-20) var(--px-17) var(--px-20) var(--px-46);
	font-size: var(--px-14);
	overflow-x: hidden;
	${(props) => (props.isProcessing ? 'opacity: 0.3; pointer-events: none;' : '')}
	section:first-child {
		border-top: unset;
	}
	.body-special-accordion-content-list-header {
		border-bottom: var(--px-1) solid var(--neutrals-200);
		.bodySpecialAccordionContentListHeaderText {
			cursor: pointer;
		}
	}
	& + .StyledBodySpecialAccordionContentList {
		padding-top: 0;
		padding-bottom: 0;
	}
`;

const StyledBodySpecialAccordionContentListTitle = styled.section`
	padding-bottom: var(--px-10);
`;
